export interface HierarchyModel {
  restrictedAccess: {
    status: boolean;
    start: string;
    end: string;
    timeZone: string;
  };
  _id: string;
  order: number;
  name: string;
}
